export const GET_FILES = 'GET_FILES';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
export const FETCH_FILE_DATA = 'FETCH_FILE_DATA';
export const SET_FILE_DATA = 'SET_FILE_DATA';
export const UPDATE_FILE = 'UPDATE_FILE';
export const DELETE_FILE = 'DELETE_FILE';
